import React from 'react'
import InputBox from '../../../common/InputBox'

class Allowance extends React.Component {
  handleAmount = (e) => {
    const value = e.target.value.replace(/,/g, '')
    const amount = value ? parseInt(value) : null
    this.props.onChange(this.props.type, {
      amount: amount,
      error: null
    })
  }

  handleFrequency = (frequency) => {
    this.props.onChange(this.props.type, { frequency: frequency })
  }

  render() {
    const {
      amount,
      frequency,
      errors,
    } = this.props

    return (
      <div>
        <InputBox
          label={ `How much untaxed allowance do you receive?` }
          labelClass='grey'
          type={ 'Allowance' }
          amount={ amount }
          frequency={ frequency }
          handleAmount={ this.handleAmount }
          handleFrequency={ this.handleFrequency }
          errorMessage={ errors && errors.amount }
          inputMode='numeric'
        />
      </div>
    )
  }
}

export default Allowance
